import React from 'react';

const WhatWeDoSection = () => {
  const services = [
    {
      id: 1,
      title: 'Custom Web & Enterprise Portals',
      description: 'High-performance, secure web applications built for absolute scalability and seamless user experience.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
      image: '../img/web.png'
    },
    {
      id: 2,
      title: 'Native & Cross-Platform Apps',
      description: 'Robust Android & iOS solutions tailored for speed, high user retention, and business growth.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      image: '../img/app.png'
    },
    {
      id: 3,
      title: 'Cloud Infrastructure & DevOps',
      description: 'Optimized cloud architectures and deployment pipelines ensuring maximum uptime and cost-efficiency.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
        </svg>
      ),
      image: '../img/devops.png'
    },
    {
      id: 4,
      title: 'AI Solutions & Automation',
      description: 'Intelligent systems designed to accelerate heavy workflows, reduce operational costs, and drive data-backed decisions.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
        </svg>
      ),
      image: '../img/ai.png'
    },
    {
      id: 5,
      title: 'Custom ERP & CRM Integration',
      description: 'Tailored enterprise platforms to streamline complex operations and unify your business operations.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      image: '../img/erp.png'
    },
    {
      id: 6,
      title: 'Cybersecurity & IT Compliance',
      description: 'Enterprise-grade protection frameworks ensuring strict data integrity and global regulatory alignment.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      image: '../img/cyber.png'
    }
  ];

  return (
    <section id="what-we-do" className="relative bg-gray-50 py-20 lg:py-32 overflow-hidden border-b border-gray-200">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-30 mix-blend-luminosity z-0 pointer-events-none" style={{
        backgroundImage: 'url(\'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80\')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}></div>
      <div className="absolute inset-0 bg-gradient-to-b from-gray-50/90 via-white/80 to-gray-50/90 backdrop-blur-md z-0 pointer-events-none"></div>
      <div className="absolute -left-40 top-40 w-96 h-96 bg-amber-500/5 rounded-full blur-[100px] pointer-events-none z-0"></div>
      <div className="absolute -right-40 bottom-20 w-96 h-96 bg-blue-600/5 rounded-full blur-[100px] pointer-events-none z-0"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center border border-gray-200 px-4 py-2 bg-white/80 backdrop-blur-sm text-xs font-bold uppercase tracking-widest text-amber-600 mb-6 rounded-md shadow-sm">
            <span className="w-2 h-2 bg-amber-500 rounded-full mr-2 animate-pulse"></span>
            What We Do
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight uppercase mb-6 text-gray-900">
            Digital Services That Move <br className="hidden sm:block" /> <span className="text-amber-600">Businesses Forward</span>
          </h2>
          
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
            End-to-end IT solutions delivering speed, premium quality, and full customization to scale your enterprise.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id}
              className="group relative bg-black rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 cursor-default min-h-[340px] flex flex-col justify-between border border-gray-800 hover:border-amber-500/50"
            >
              {/* Background Image */}
              <img 
                src={service.image} 
                alt={service.title} 
                className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-transform duration-1000 group-hover:scale-110"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent group-hover:from-black/90 group-hover:via-black/20 group-hover:to-transparent transition-colors duration-500"></div>
              
              {/* Icon Section */}
              <div className="relative z-10 p-8 pb-0">
                <div className="w-16 h-16 bg-white/10 backdrop-blur-md border border-white/20 text-amber-500 rounded-2xl flex items-center justify-center group-hover:bg-amber-500 group-hover:text-white group-hover:border-amber-500 transition-all duration-300 shadow-xl">
                  {service.icon}
                </div>
              </div>
              
              {/* Content Section */}
              <div className="relative z-10 p-8 pt-4">
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors">{service.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm group-hover:text-gray-200 transition-colors">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
